import { useState } from "react";
import {
  CreateTableNew as CreateTable,
} from '../../../../common/APICommon';

import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from '@mui/icons-material/History';

export function ViewHistoryForm({ isOpen, onClose, requests }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  if (!isOpen) return null;

  const headers = [
    "Ref No.",
    "Date Requested",
    "Status",
    "Amount",
    "Reason",
  ];

  // MATCHING BACKEND ENTITY/DTO fields
  const accessors = [
    "referenceNumber",
    "requestedDate",
    "statusDisplay",
    "amountDisplay",
    "reason",
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString();
  };

  const formatAmount = (value) => {
    return `₱${value.toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "Approved": return "text-green-600 font-bold text-xs";
      case "Pending": return "text-orange-500 font-bold text-xs";
      case "Disapproved": return "text-red-500 font-bold text-xs";
      case "Cancelled": return "text-gray-400 font-bold text-xs";
      default: return "text-gray-500 text-xs";
    }
  };

  const formattedRequests = (requests || []).map(req => ({
    ...req,
    requestedDate: formatDate(req.requestedDate),
    statusDisplay: (
      <span className={getStatusStyle(req.status)}>
        {req.status}
      </span>
    ),
    amountDisplay: (
      <div className="text-right font-semibold">
        {formatAmount(req.amount)}
      </div>
    )
  }));

  const handleClose = () => {
    setCurrentPage(1);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-4 overflow-auto animate-fadeIn">
      <div className="bg-white w-full max-w-6xl rounded-xl shadow-2xl flex flex-col max-h-[90vh]">

        {/* Header - Styled like CrewDetailModal */}
        <div className="flex justify-between items-center px-6 py-3 border-b bg-gray-50 rounded-t-xl">
          <div className="flex items-center gap-3">
            <HistoryIcon className="text-blue-900" fontSize="small" />
            <div>
              <h2 className="text-sm font-bold text-blue-900 uppercase tracking-wide">
                Salary Advance Request History
              </h2>
            </div>
          </div>
          <button
            onClick={handleClose}
            className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-md bg-transparent border-none cursor-pointer transition-colors"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>

        {/* Body - Standardized Table */}
        <div className="overflow-y-auto flex-grow p-4 bg-white">
          <CreateTable
            tableName="SalaryAdvanceHistoryTable"
            headers={headers}
            accessors={accessors}
            data={formattedRequests}
            actions={[]}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={itemsPerPage}
            totalItems={formattedRequests.length}
          />
        </div>

        {/* Footer - Styled like CrewDetailModal */}
        <div className="px-6 py-3 border-t bg-gray-50 flex justify-end rounded-b-xl">
          <button
            onClick={handleClose}
            className="px-6 py-1.5 bg-slate-600 text-white rounded-lg cursor-pointer hover:bg-slate-700 border-none transition-colors text-xs font-semibold uppercase tracking-wide shadow-sm"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}